import { useEffect, useState } from "react";
import PropTypes from 'prop-types';

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

// Soft UI Dashboard PRO React example components
import GroupCard from "components/Groups/GroupCard";

import { useQuery } from '@tanstack/react-query';
import { useAuth0 } from "@auth0/auth0-react";

// API/MODELS
import groupAPI from "services/api/groups";
import bksAPI from "services/api/bks";
import userAPI from "services/api/user";

// Images
import { processGroupData } from "utils/group";

import { disableMap } from "utils/map";
import { useSoftUIController } from "hooks/context";
import { wrapper, loadingScreen } from "utils/wrapper";
import { Box, Card } from "@mui/material";

function ClearwayDeviceGroupsView({ map, user }) {
  disableMap(map);

  groupAPI.loadToken(useAuth0());
  bksAPI.loadToken(useAuth0());
  const [controller] = useSoftUIController();
  const { deviceLayout, userPermissions } = controller;

  const showAdvancedDeviceLevel = userPermissions.indexOf('devices-advanced:view') >= 0;

  const groups = useQuery({
    queryKey: ['getAllGroups'],
    queryFn: async () => {
      return await groupAPI.getAllGroups();
    }
  });

  const devices = useQuery({
    queryKey: ['getAllDevices'],
    queryFn: async () => {
      return await bksAPI.getAllDevices();
    }
  });

  if (groups.isLoading || devices.isLoading) {
    return loadingScreen(deviceLayout, true);
  }

  if (groups.error || devices.error) {
    return wrapper("An error has occurred");
  }

  if (!groups.data || !devices.data) {
    return loadingScreen(deviceLayout, false);
  }

  var groups_data = groups.data.filter((row) => row.type == "clearways").map(function (group) {
    var ret = processGroupData(group, devices.data, showAdvancedDeviceLevel);
    return ret;
  }).filter((row) => { return typeof row.parent_id == 'undefined' });

  return wrapper((
    <Box p={1}>
      <Card sx={{minHeight: deviceLayout == 'mobile' ? 'calc(100svh - 5.75rem - 8px)' : 'calc(100svh - 6.5rem - 16px)', height: '100%', backgroundColor: '#eee'}}>
        <SoftBox display="flex" flexDirection="column" p={2}>
          <SoftBox mb={1}>
            <SoftTypography pl={1} variant="h4">
              Clearways Groups
            </SoftTypography>
          </SoftBox>
          <Grid container spacing={3}>
            {groups_data.map((group) => (
              <Grid item xxs={12} md={6} lg={4} x3l={3} key={group.group_id} onClick={() => { group.group_id }}>
                <GroupCard group={group} />
              </Grid>
            ))}
          </Grid>
        </SoftBox>
      </Card>
    </Box>
  ), deviceLayout, true
  );
}

ClearwayDeviceGroupsView.propTypes = {
  map: PropTypes.object,
  user: PropTypes.object,
}

export default ClearwayDeviceGroupsView;
